import HRRanking from "./HRRanking";
export default HRRanking;
